/* Constants to be used across the app */

export const APP_CONSTANTS = {
    APP_TITLE: 'Consuli',
    PAGE_NOT_FOUND: 'Page Not found',
};

export const API_CONSTANTS = {
    API_URL: 'http://localhost:3001/',
};
